<div fxLayout="row" fxLayoutAlign="center center">
    <mat-card class="login-card">
        <mat-card-header>
            <h4 *ngIf="changeUserPassword">{{ "change-password.user-header" | translate }}</h4>
            <h4 *ngIf="!changeUserPassword">{{ "change-password.own-header" | translate }}</h4>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="changePasswordForm">
                <div fxLayout="column" class="form-group">
                    <mat-form-field [ngStyle]="{
          'width.ch': 30,
          'min-width.px': 400
        }">
                        <mat-label>{{ "change-password.username" | translate }}</mat-label>
                        <input matInput class="form-control" formControlName="username" />
                        <mat-error *ngIf="changePasswordForm.controls['username'].errors">{{ "error.required" |
                            translate }}</mat-error>
                    </mat-form-field>
                    <mat-form-field *ngIf="!changeUserPassword" [ngStyle]="{
          'width.ch': 30,
          'min-width.px': 400
        }">
                        <mat-label>{{ "change-password.old-password" | translate }}</mat-label>
                        <input matInput type="password" formControlName="password" class="form-control" #password />
                        <mat-icon style="cursor: pointer; font-size: 26px;" matSuffix
                            (mousedown)="password.type = 'text'" (mouseup)="password.type = 'password'" [inline]="true">
                            {{ password.type == "password" ? "visibility_off" : "visibility" }}
                        </mat-icon>
                        <mat-error *ngIf="changePasswordForm.controls['password'].errors">{{ "error.required" |
                            translate }}</mat-error>
                    </mat-form-field>

                    <mat-form-field [ngStyle]="{
                'width.ch': 30,
                'min-width.px': 400
              }">
                        <mat-label>{{ "change-password.new-password" | translate }}</mat-label>
                        <input matInput type="password" formControlName="newPassword" class="form-control"
                            #newPassword />
                        <mat-icon style="cursor: pointer; font-size: 26px;" matSuffix
                            (mousedown)="newPassword.type = 'text'" (mouseup)="newPassword.type = 'password'"
                            [inline]="true">

                            {{ newPassword.type == "password" ? "visibility_off" : "visibility" }}
                        </mat-icon>
                        <mat-error *ngIf="changePasswordForm.controls['newPassword'].errors?.['required']">{{ "error.required" | 
                            translate }}</mat-error>
                        <mat-error *ngIf="changePasswordForm.controls['newPassword'].errors?.['pattern']">{{ "error.password_pattern" | 
                            translate }}</mat-error>

                    </mat-form-field>

                    <mat-form-field [ngStyle]="{'width.ch': 30,'min-width.px': 400 }">
                        <mat-label>{{ "change-password.new-password-repeat" | translate }}</mat-label>
                        <input matInput 
                           type="password" formControlName="newPasswordRepeat" class="form-control"
                            #newPasswordRepeat />
                        <mat-icon style="cursor: pointer; font-size: 26px;" matSuffix
                            (mousedown)="newPasswordRepeat.type = 'text'"
                            (mouseup)="newPasswordRepeat.type = 'password'" [inline]="true">
                            {{ newPasswordRepeat.type == "password" ? "visibility_off" : "visibility" }}
                        </mat-icon>
                        <mat-error *ngIf="changePasswordForm.controls['newPasswordRepeat'].errors?.['required']">{{ "error.required" |
                            translate }}</mat-error>
                    </mat-form-field>
                    <mat-error *ngIf="changePasswordForm.hasError('newPasswordsNoMatch') && changePasswordForm.controls['newPasswordRepeat'].touched">
                        {{ "error.password_matches" | translate }}
                    </mat-error>

                    <div style="margin-top: 15px;">
                        <button mat-raised-button (click)="onSubmit()" [disabled]="!changePasswordForm.valid">
                            {{ "change-password.button" | translate }}
                        </button>
                    </div>

                </div>
            </form>
        </mat-card-content>
    </mat-card>
</div>